import { useFeatureGate } from "@statsig/react-bindings";
import { useCallback } from "react";
import {
  useVideoPlatform,
  useVideoPlatformCallback,
} from "../../../hooks/useVideoPlatform";
import { telehealthManualAdmissionFlowGate } from "../../../statsig/gates";
import { Statsig } from "../../../statsig/StatsigProvider";

/**
 * Use this to check whether to show the rejoin flow and reconnecting indicators
 * for Zoom. The Zoom check is just extra guard to limit blast radius, and this
 * feature should work for Twilio as well. If enabled for Twilio, then Twilio
 * users should see reconnection indicators as expected, but they won't see a
 * manual way to rejoin while in a session (that's behavior that's [exclusive
 * to
 * Zoom](https://devforum.zoom.us/t/how-to-handle-internet-disconnection-properly/65018)).
 */
export function useIsRejoinEnabled() {
  const { value: isManualAdmissionFlowEnabled } = useFeatureGate(
    telehealthManualAdmissionFlowGate,
  );
  const videoPlatform = useVideoPlatform();
  const getVideoPlatform = useVideoPlatformCallback();

  const checkRejoinIsEnabled = useCallback(
    () =>
      getVideoPlatform() === "zoom" &&
      Statsig.checkGate(telehealthManualAdmissionFlowGate),
    [getVideoPlatform],
  );

  return [
    videoPlatform === "zoom" && isManualAdmissionFlowEnabled,
    checkRejoinIsEnabled,
  ] as const;
}
